module.exports = __webpack_public_path__ + "static/img/200_phase_function_Paper_PointsHejduk_Prediction.595a896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/200_phase_function_Paper_PointsHejduk_Prediction.png
// module id = /FaC
// module chunks = 0